
import { TextField, MenuItem, ToggleButtonGroup, ToggleButton, InputAdornment } from '@mui/material';
import Search from '@mui/icons-material/Search';
import { useFilter } from '../contexts/FilterContext';
import { useEffect } from 'react';

type Option = {
  code: string;
  value: string;
  sectorCode?:string;
};

type FilterRowProps = {
  searchJob?: boolean;
  sectors?: Option[];
  occupations?: Option[];
  skills?: Option[];
  showTimeRange?: boolean;
};


const commonSx = {
  width: '250px',
  '& .MuiOutlinedInput-root': {
    color: '#646A77',
    '& fieldset': {
      borderColor: '#646A77',
    },
    '&:hover fieldset': {
      borderColor: '#646A77',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#646A77',
    },
  },
  '& .MuiSelect-select': {
    color: '#646A77',
  },
  '& .MuiSelect-icon': {
    color: '#646A77',
  },
  '& .MuiInputLabel-root': {
    color: '#646A77',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#646A77',
  },
  '& .MuiSelect-select em': {
    color: '#646A77',
    fontStyle: 'normal',
    opacity: 1,
  }
};

const timeRanges = ['3 Months', '6 Months', '1 Year', '3 Years'];
const FilterRow: React.FC<FilterRowProps> = ({ searchJob, sectors, occupations, skills, showTimeRange }) => {

  const {
    timeRange,
    setTimeRange,
    selectedSector,
    setSelectedSector,
    selectedOccupation,
    setSelectedOccupation,
    selectedSkill,
    setSelectedSkill,
    selectedTab
  } = useFilter();

useEffect(() => {
    setTimeRange('3 Years');
    setSelectedSector("K");
    setSelectedOccupation("All");
}, [selectedTab, setTimeRange, setSelectedOccupation, setSelectedSector]);

const filteredOccupations = occupations?.filter(
  (occ) => occ.sectorCode === selectedSector
);

const handleResetFilters = () => {
  setSelectedSector("K");
  setSelectedOccupation("All");
  setSelectedSkill("");
  const defaultRange = "3 Years";

  setTimeRange(defaultRange);
};


  return (
    <div>
      <div className="mb-2">Filter:</div>
      <div className="d-flex flex-wrap gap-3 mb-3">
        {searchJob && (<TextField
          size="small"
          placeholder="Search Job ..."
          variant="outlined"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search style={{ color: '#646A77' }} />
              </InputAdornment>
            )
          }}
          sx={commonSx}
        />)}
        {sectors && (
          <TextField
            select
            size="small"
            label="Sector"
            value={sectors?.find(opt => opt.code === selectedSector)?.value || ""}
            onChange={(e) => {
              const selected = sectors?.find(opt => opt.value === e.target.value);
              if (selected) {
                setSelectedSector(selected.code);
                setSelectedOccupation("All");
              }
            }}
            sx={commonSx}
          >
            <MenuItem value="">
              <em>Choose sector...</em>
            </MenuItem>
            {sectors.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.value}
              </MenuItem>
            ))}
          </TextField>
        )}

        {occupations && (
          <TextField
            select
            size="small"
            label="Occupation"
             value={filteredOccupations?.find(opt => opt.code === selectedOccupation)?.value || ""}
            onChange={(e) => {
              const selected = filteredOccupations?.find(opt => opt.value === e.target.value);
              if (selected) setSelectedOccupation(selected.code);
            }}
            sx={commonSx}
  disabled={!selectedSector}
          >
            <MenuItem value="">
              <em>Choose occupation...</em>
            </MenuItem>
            {filteredOccupations?.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.value}
              </MenuItem>
            ))}
          </TextField>
        )}

        {skills && (
          <TextField
            select
            size="small"
            label="Skills"
            value={selectedSkill}
            onChange={(e) => setSelectedSkill(e.target.value)}
            sx={commonSx}
          >
            <MenuItem value="">
              <em>Choose skill...</em>
            </MenuItem>
            {skills.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.code}
              </MenuItem>
            ))}
          </TextField>
        )}

        <button
          type="button"
          className="button"
          onClick={handleResetFilters}
          style={{
            border: '1px solid #043C5B',
            backgroundColor: '#ffffff',
            color: '#043C5B',
            borderRadius: '20px',
            padding: '6px 16px',
            fontWeight: 500,
            width: 150
          }}
        >
          Reset Filters
        </button>
        {/* <button
          type="button"
          className="button border-0"
          style={{
            border: '1px solid #043C5B',
            backgroundColor: '#043C5B',
            color: '#ffffff',
            borderRadius: '20px',
            padding: '6px 16px',
            fontWeight: 500,
            width: 150
          }}
        >
          Apply Filters
        </button> */}
      </div>

{showTimeRange && (
  <ToggleButtonGroup
    size="small"
    exclusive
    value={timeRange}
    onChange={(e, value) => value && setTimeRange(value)}
    className="ms-auto"
  >
    {timeRanges.map(range => {
      const isDisabledTab = ['Aggressive', 'Conservative', 'Realistic'].includes(selectedTab);
      const isShortTerm = ['3 Months', '6 Months', '1 Year'].includes(range);

      return (
        <ToggleButton
          key={range}
          value={range}
          disabled={isDisabledTab && isShortTerm}
          sx={{
            textTransform: 'none',
            color: '#374151',
            borderColor: '#D7DAE0',
            padding: "8px 20px",
            fontSize: 16,
            backgroundColor: '#ffffff',
            borderLeft: '1px solid #D7DAE0',
            borderRight: '1px solid #D7DAE0',
            '&.Mui-selected': {
              backgroundColor: '#043C5B',
              color: '#fff',
              '&:hover': {
                backgroundColor: '#043C5B',
              }
            }
          }}
        >
          {range}
        </ToggleButton>
      );
    })}
  </ToggleButtonGroup>
)}

    </div>
  );
}

export default FilterRow;